
const m = window.require("@glimmer/manager");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
